import React from 'react';
import { RegexHelpers } from '../../../lib/Helpers';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Alert, TextField } from '@mui/material';

export default function Manage2faSmsStep1(props) {
    const dialogSubmit = React.useRef(props.dialogSubmit);
    const [showFormError, setShowFormError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(null);

    const initialValues = {
        phoneNumber: props.profilePhoneNumber
    };

    const validationSchema = yup.object({
        phoneNumber: yup
            .string()
            .required('Phone number is required')
            .matches(RegexHelpers.getPhoneRegex(), 'Phone number is not valid'),
    });

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                setShowFormError(false);
                setErrorMessage(null);
                if (formik.isValid) {
                    props.onValidate(formik?.values);
                }
            }
            catch(err) {
                setShowFormError(true);
                if (err.response && err.response.data) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
            finally {
                formik.setSubmitting(false);
            }
        },
    });

    React.useEffect(() => {
        if (props.dialogSubmit !== dialogSubmit.current) {
            dialogSubmit.current = props.dialogSubmit;
            formik.handleSubmit();
        }
    });

    return (
        <div className='ignoreCustomFormStyles'>
            <>
                {showFormError && (
                    <Alert sx={{ mt: 2, mb: 2 }} severity="error">{errorMessage}</Alert>
                )}
                <TextField sx={{ mt: 2 }}
                    type="text"
                    name="phoneNumber"
                    label="Phone Number"
                    fullWidth
                    value={formik.values.phoneNumber}
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.phoneNumber)}
                    helperText={formik.errors.phoneNumber}
                />
            </>
        </div>
    );
}